import React from 'react';
import PropTypes from 'prop-types';
import {
    SimpleModal,
    ModalHeader,
    ModalBody,
    ModalFooter,
  } from '@ami/react/core';
  import { Button } from '@ami/react/core';
import ReviewQuoteProductQuantity from './ReviewQuoteProductQuantity';

export default class ReviewQuoteProductQuantityModal extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            saving: false,
            newValue: ''
        };
    }

    static propTypes = {
        actualValue: PropTypes.number.isRequired,
        maxQuantity: PropTypes.number,
        onChanged: PropTypes.func.isRequired,
        show: PropTypes.bool.isRequired,
        onHide: PropTypes.func.isRequired,
        productName: PropTypes.string.isRequired
    };

    async componentDidMount() {
        this.setState({ newValue: this.props.actualValue });
    }

    hide = () => this.props.onHide();

    save = () => {
        if (this.state.newValue) {
            this.setState({ saving: true });
            this.props.onChanged(this.state.newValue);
            this.hide();
            this.setState({ saving: false });
        }
    };

    render() {
        const { newValue } = this.state;
        const { show, maxQuantity,productName } = this.props;
        if (!show) return null;

        return (
            <SimpleModal show={show}>
                <ModalHeader title={`Change Quantity - ${productName}`}/>
                <ModalBody>
                    <form className="container">
                        <div className="row">
                            <div className="col">
                                <ReviewQuoteProductQuantity
                                    value={newValue}
                                    maxQuantity={maxQuantity}
                                    onChanged={e => this.setState({ newValue: e })}
                                />
                            </div>
                        </div>
                    </form>
                </ModalBody>
                <ModalFooter>
                    <button className="btn btn-secondary" onClick={this.hide}>
                        Cancel
                    </button>
                    <Button
                        label="Save"
                        className="btn btn-primary"
                        onClick={this.save}
                        showSpinner={this.state.saving}
                        disabled={this.state.saving}
                    />
                </ModalFooter>
            </SimpleModal>
        );
    }
}
